/* eslint-disable no-console */
import { Form, Modal } from 'antd';
import propType from 'prop-types';
import React, { useEffect, useState } from 'react';
import createFreshsaleRecord from '../../../../api/services/createFreshsaleRecord';
import sendMailToSale from '../../../../api/services/sendMailToSale';
import { API_RESPONSE_STATUS } from '../../../../config/constant';
import { Notification, RegisterForm } from './components';

export default function Banner({ location }) {
  const [submitLoadingStatus, setSubmitLoadingStatus] = useState(false);
  const [registerForm] = Form.useForm();
  const [showRegisterForm, setShowRegisterForm] = useState(false);
  const [registerFormStatus, setRegisterFormStatus] = useState(
    API_RESPONSE_STATUS.DEFAULT
  );

  const handleSubmitForm = async (data) => {
    try {
      const postData = {
        name: data.name,
        company: data.company,
        email: data.email,
        'g-recaptcha-response': data['g-recaptcha-response'],
        help: `position:${data.position};phoneNumber:${data.phoneNumber};service:${data.service}`
      };

      const postDataFreshWork = {
        ...data,
        help: data.service
      };

      setSubmitLoadingStatus(true);
      const result = await Promise.all([
        sendMailToSale(postData),
        createFreshsaleRecord(postDataFreshWork)
      ]);
      setRegisterFormStatus(
        result[0]?.statusCode === 200
          ? API_RESPONSE_STATUS.SUCCESS
          : API_RESPONSE_STATUS.FAIL
      );
    } catch (error) {
      setRegisterFormStatus(API_RESPONSE_STATUS.FAIL);
    } finally {
      setSubmitLoadingStatus(false);
    }
  };

  const addQueryStringWithoutRefresh = (queryString) => {
    const { host, pathname, protocol } = window?.location;

    if (window?.history.pushState) {
      const newUrl = `${protocol}//${host}${pathname}${queryString}`;
      window.history.pushState({ path: newUrl }, '', newUrl);
    }
  };

  const handleCancelForm = () => {
    registerForm.resetFields();
    setRegisterFormStatus(API_RESPONSE_STATUS.DEFAULT);
    setShowRegisterForm(false);
    addQueryStringWithoutRefresh('');
  };

  const handleShowRegisterForm = () => {
    setShowRegisterForm(true);
    addQueryStringWithoutRefresh('?register-form=true');
  };

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('register-form');
    if (query !== null) {
      setShowRegisterForm(true);
    }
  }, [setRegisterFormStatus, location.search]);

  return (
    <section className="banner">
      <div className="banner__container">
        <h2 className="banner__heading">LET&apos;S TALK</h2>
        <h3 className="banner__title">We&apos;re here to help!</h3>
        <p className="banner__content">
          Let’s transform your HR into an advanced and centralized solution.
        </p>
        <div className="banner__btn-container">
          <span
            className="banner__btn register-btn"
            onClick={handleShowRegisterForm}
          >
            Register for 21-day free trial
          </span>
          <span className="banner__btn publish-btn">
            <a
              href="https://recruiter.bravosuite.io"
              target="_blank"
              rel="noreferrer"
            >
              Publish your opening jobs free of charge
            </a>
          </span>
        </div>
        <figure className="banner__logo">
          <img src="/svg/home/banner.svg" alt="banner logo" />
        </figure>
      </div>
      <Modal
        centered
        className="register-dialog"
        closable={false}
        visible={showRegisterForm}
        footer={null}
        onCancel={handleCancelForm}
        onOk={() => setShowRegisterForm(false)}
        width="auto"
        zIndex={10}
      >
        {registerFormStatus === API_RESPONSE_STATUS.DEFAULT ? (
          <RegisterForm
            form={registerForm}
            onFinish={handleSubmitForm}
            onCancel={handleCancelForm}
            submitLoadingStatus={submitLoadingStatus}
          />
        ) : (
          <Notification
            status={registerFormStatus}
            onCancel={handleCancelForm}
          />
        )}
      </Modal>
    </section>
  );
}

Banner.propTypes = {
  location: propType.shape({
    search: propType.string
  }).isRequired
};
